<template>
  <v-container fluid class="mt-16">
    <div class="imprimir">
      <TicketDeCompra />
    </div>
    <div class="noimprimir">
      <v-row>
        <v-col>
          <v-card>
            <v-card-title> </v-card-title>
            <v-row>
              <v-col cols="4"> </v-col>
              <v-col cols="4">
                <div style="text-align:center;">
                  <span style="font-weight:bold;font-size:40px;color:black;"
                    >Corte de caja</span
                  ><br />
                  <span style="font-weight:bold;font-size:16px;color:gray;">
                    Entrada efectivo:
                    <div v-if="objetoInfoCorteDeCajaSucursal.ESTADO == 0">
                      {{
                        formateaMoneda(
                          objetoInfoCorteDeCajaSucursal.ENTRADA_EFECTIVO
                        )
                      }}
                      <br />
                    </div>
                    <div v-if="objetoInfoCorteDeCajaSucursal.ESTADO == 1">
                      {{
                        formateaMoneda(
                          parseFloat(
                            objetoInfoCorteDeCajaSucursal.ENTRADA_EFECTIVO -
                              objetoInfoCorteDeCajaSucursal.SALIDA_EFECTIVO
                          )
                        )
                      }}
                      <br />
                    </div>
                    Salida efectivo:
                    <div v-if="objetoInfoCorteDeCajaSucursal.ESTADO == 0">
                      {{
                        formateaMoneda(
                          objetoInfoCorteDeCajaSucursal.SALIDA_EFECTIVO
                        )
                      }}
                      <br />
                    </div>
                    <div v-if="objetoInfoCorteDeCajaSucursal.ESTADO == 1">
                      {{ formateaMoneda(0) }} <br />
                    </div>

                    Sucursal: {{ objetoInfoCorteDeCajaSucursal.SUCURSAL }}
                    <br />
                    Fecha: {{ objetoInfoCorteDeCajaSucursal.FECHA }} <br />
                    <div v-if="objetoInfoCorteDeCajaSucursal.ESTADO == 1">
                      Fecha y hora de corte:
                      {{ objetoInfoCorteDeCajaSucursal.FECHA_HORA_CORTE }}
                      <br />
                    </div>
                    <div
                      style="color:orange;"
                      v-if="objetoInfoCorteDeCajaSucursal.ESTADO == 0"
                    >
                      Estado: Corte pendiente de realizar.
                    </div>
                    <div
                      style="color:green;"
                      v-if="objetoInfoCorteDeCajaSucursal.ESTADO == 1"
                    >
                      Estado: Corte realizado con éxito.
                    </div>
                  </span>
                </div>
              </v-col>
              <v-col cols="4"> </v-col>
            </v-row>
            <v-row>
              <v-col cols="4"></v-col>
              <v-col
                ><v-text-field
                  v-if="objetoInfoCorteDeCajaSucursal.ESTADO == 0"
                  outlined
                  autofocus
                  label="Salida de dinero"
                  v-model="salidaDinero"
                  clearable
                  @focus="$event.target.select()"
                ></v-text-field>
                <v-btn
                  v-if="objetoInfoCorteDeCajaSucursal.ESTADO == 0"
                  block
                  dark
                  color="blue"
                  @click="realizarCorteDeCaja()"
                  >Aceptar</v-btn
                >
                <v-btn
                  class="mt-2"
                  block
                  dark
                  @click="descargarExcelEnvios()"
                  color="green"
                  >DESCARGAR EXCEL ENVIOS DE HOY</v-btn
                >
                <v-btn
                  v-if="objetoInfoCorteDeCajaSucursal.ESTADO == 1"
                  block
                  color="blue"
                  @click="imprimirCorteDeCaja()"
                  dark
                  >imprimir comprobante último corte<v-icon medium class="mr-2">
                    mdi-printer
                  </v-icon></v-btn
                >
              </v-col>
              <v-col cols="4"></v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-snackbar
        v-model="snackbarExito"
        timeout="2000"
        rounded="pill"
        centered
        elevation="8"
        color="blue darken-1"
        ><span style="font-size:20px;">
          {{ mensajeSnackbarExito }} <v-icon medium> mdi-check-circle </v-icon>
        </span></v-snackbar
      >
    </div>
  </v-container>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { FormatoMoneda } from "@/Utils/Utils";
import TicketDeCompra from "@/components/TicketDeCompra.vue";
import { exportExcel } from "../Utils/Utils";
export default {
  data: () => ({
    salidaDinero: 0,
    snackbarExito: false,
    mensajeSnackbarExito: "Corte de caja realizado con éxito"
  }),
  components: {
    TicketDeCompra
  },
  methods: {
    ...mapActions("enviosInsercion", ["getEnviosParaExcel"]),
    ...mapActions("cortesDeCaja", [
      "getEfectivoCaja",
      "hacerCorteDeCaja",
      "destroyCortesDeCaja"
    ]),
    ...mapActions("abonosEnvios", ["imprimirTicketCorteDeCaja"]),
    async imprimirCorteDeCaja() {
      await this.imprimirTicketCorteDeCaja({
        entradaDeDinero: this.objetoInfoCorteDeCajaSucursal.ENTRADA_EFECTIVO,
        salidaDeDinero: this.objetoInfoCorteDeCajaSucursal.SALIDA_EFECTIVO,
        usuarioCorte: this.objetoInfoCorteDeCajaSucursal.USUARIO,
        fechaYHoraDelCorte: this.objetoInfoCorteDeCajaSucursal.FECHA_HORA_CORTE,
        dineroActualEnCaja:
          this.objetoInfoCorteDeCajaSucursal.ENTRADA_EFECTIVO -
          this.objetoInfoCorteDeCajaSucursal.SALIDA_EFECTIVO
      });
      window.print();
    },
    formateaMoneda(moneda) {
      return FormatoMoneda.format(moneda);
    },
    async descargarExcelEnvios() {
      let fecha = this.objetoInfoCorteDeCajaSucursal.FECHA;

      await this.getEnviosParaExcel({
        fecha_inicio: fecha,
        fecha_fin: fecha
      });
      exportExcel(this.historialEnviosExcel.DATOS, fecha);
    },
    async realizarCorteDeCaja() {
      const res = await this.hacerCorteDeCaja({
        Salida: this.salidaDinero,
        idSucursal: this.idSucursalAConsultarEfectivo
      });
      if (res[0]) {
        this.snackbarExito = true;
        await this.getEfectivoCaja(this.idSucursalAConsultarEfectivo);
      }
    }
  },
  async mostrarDialogExitoCorteDeCaja() {},
  async mounted() {
    await this.getEfectivoCaja(this.idSucursalAConsultarEfectivo);
  },
  async beforeDestroy() {
    await this.destroyCortesDeCaja();
  },
  computed: {
    ...mapState({
      idSucursalAConsultarEfectivo: state =>
        state.sesion.logedInUserInfo.sucursal,
      objetoInfoCorteDeCajaSucursal: state =>
        state.cortesDeCaja.objetoInfoCorteDeCajaSucursal
    }),
    ...mapState("enviosInsercion", {
      historialEnviosExcel: state => state.historialEnviosExcel
    })
  }
};
</script>

<style lang="css" scoped>
.imprimir {
  display: none;
}
@media print {
  .noimprimir {
    display: none;
  }
  .imprimir {
    display: block;
  }
}
</style>
